<template>
  <div :id="$route.name">
    <card back>
      <template v-slot:header>
        <h4 class="d-inline">دسترسی کاربران کـارهـا</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="container">
          <h3 v-if="!AddShow">
            <i class="px-3"
              :class="[ShowForm ? ['fas Pointer', 'fa-times', 'text-danger'] : ['fas Pointer', 'fa-plus', 'text-success']]"
              @click="ShowForm = !ShowForm"></i>
          </h3>
          <h3 v-else><i class="px-3 fas fa-times text-danger" @click="AddShow = false"></i></h3>
          <div class="d-flex mb-3" v-if="ShowForm">
            <div class="col-md-8 col-12 px-3">
              <small id="LblDepartmentName">انتخاب کاربر</small>
              <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" :rownumintable="3"
                :defaultvalue="DataAxios.TblUserIdTask" :action="'TblCrmCombo/GetUserDatails'" :method="'POST'"
                :idinput="'UserId'" :keyItem="'UserId'">
              </SearchableCombo>
            </div>

            <div class="col-md-4 col-12 mt-4">
              <!-- <btn-save-data v-if="!ShowEditBtn" :DataParanet="DataAxios"></btn-save-data>
              <btn-edit-data v-if="ShowEditBtn" :DataParanet="DataAxios"></btn-edit-data> -->
              <button class="btn btn-success mr-5" v-if="!ShowEditBtn" @click.prevent="Submit()">ثبت اطلاعات</button>
            </div>
          </div>

          <div class="row" v-if="AddShow">
            <div class="col-md-3 col-12">
              <small id="LblUserId">اضافه به دسترسی <u class="text-info">{{ UserNameForAdd }}</u></small>
              <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResulUserId" :rownumintable="3"
                :action="'TblCrmCombo/GetUserDatails'" :method="'POST'" :idinput="'UserId'" :keyItem="'UserId'"
                :disabled="false"> </SearchableCombo>
            </div>
          </div>
          <div v-if="!ShowForm" class="row">
            <div class="col-md-3 col-12 mb-4" v-for="item in Users" :key="item.id">
              <div class="card h-100">
                <div class="card-header">
                  <i class="fad fa-users-class"></i> &nbsp; &nbsp;{{ item.namFam }}
                  <b-dropdown size="md" variant="link" class="d-inline float-left btn-more text-center"
                    toggle-class="text-decoration-none " no-caret>
                    <template #button-content>
                      <h4><i class="fad fa-ellipsis-v"></i></h4>
                    </template>
                    <b-dropdown-item @click="AddUser(item)" class="text-center">اضافه کردن کاربر</b-dropdown-item>
                    <!-- <b-dropdown-item @click="ShowEditDepartmentForm(item)" class="text-center"> ویرایش</b-dropdown-item>
                    <b-dropdown-item @click="RemoveDepartment(item)" class="text-center">حذف </b-dropdown-item> -->
                  </b-dropdown>
                </div>
                <div v-if="$store.state.renderComponentCard" class="card-body">
                  <span v-for="users in ListUsers" :key="users.id">
                    <div v-for="(items, index) in users" :key="index">
                      <span class="badge border m-1 p-2" v-if="items.tblUserId == item.id">
                        {{ items.namFam }} &nbsp;&nbsp;
                        <i @click="RemoveUser(items, item)" class="fas fa-times hover-danger"></i>
                      </span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BtnEditData from '@/components/BnpButtons/BtnEditData.vue'
import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue'
export default {
  components: { Card, SearchableCombo, BtnEditData, BtnSaveData },
  data() {
    return {
      ShowForm: false,
      ShowEditBtn: false,
      ShowEditBtn: false,
      AddShow: false,
      UserNameForAdd: '',
      UserIdForAdd: null,
      Users: [],
      ListUsers: [],
      DataAxios: {},
      DataaxiosUser: {
        Action: 'UserIdTask/Index',
        Method: 'Get',
        ArryfildValue: null,
        Token: this.$session.get('Token'),
      },
      DataAxiosPost: {
        ArryfildValue: this.DataAxios,
        Method: 'post',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
    }
  },
  methods: {

    getData() {
      this.DataaxiosUser.Action = 'UserIdTask/Index'
      this.DataaxiosUser.Method = 'Get'
      this.DataaxiosUser.ArryfildValue = null
      this.ListUsers = []
      this.$PostData(this.DataaxiosUser)
        .then((res) => {
          this.Users = res
        })
        .finally(() => {
          for (let index = 0; index < this.Users.length; index++) {
            this.DataaxiosUser.Action = 'UserIdTask/IndexUser'
            this.DataaxiosUser.methods = 'Get'
            this.DataaxiosUser.ArryfildValue = {
              Id: this.Users[index].tblUserId,
            }
            this.$GetData_Header(this.DataaxiosUser).then((data) => {
              this.ListUsers.push(data)
            })
          }
        })
    },

    Submit() {
      this.DataAxiosPost.Action = 'UserIdTask'
      this.DataAxiosPost.ArryfildValue = this.DataAxios

      this.$PostData(this.DataAxiosPost).then((data) => {
        if (data.status == 'Ok') {
          this.$mySweetPost('ثبت موفق', 'اطلاعات با موفقیت ثبت شد', 'success', 'ثبت و ادامه', 'بستن صفحه')
          this.getData()
        } else {
          if (data.eNum == '2601') {
            this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
          } else if (data.status == 'Not Ok') {
            this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
          } else {
            this.$mySweetDefaultTost('خطایی رخ داده!', '', 'error', 3000)
          }
        }
      })

    },
    AddUser(item) {
      this.ShowForm = false
      this.AddShow = true
      this.UserNameForAdd = item.namFam
      this.UserIdForAdd = item.tblUserId
    },
    GetResulUserId(data) {
      if (data.id != null) {
        if (this.AddShow) {
          var DataAxiosAddUser = {
            Action: 'UserIdTask/B_AddUser',
            Method: 'Post',
            ArryfildValue: {
              TblUserId: this.UserIdForAdd,
              TblTaskUserIdTask: data.id,
              TblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
            },
            Token: this.$session.get('Token'),
          }
          this.$PostData(DataAxiosAddUser)
            .then((res) => {
              if (res.status == 'Ok') {
                this.$mySweetDefaultTost('عملیات موفق', 'کاربر با موفقیت به لیست دسترسی اضافه شد', 'success', 4000)
                this.getData()
                this.$store.state.renderComponentCard = false
                this.$nextTick(() => {
                  this.$store.state.renderComponentCard = true
                })
              } else {
                this.$mySweetDefaultTost('عملیات ناموفق', res.msg, 'error', 4000)
              }
            })
            .finally(() => {

            })
        } else {
          this.DataAxios.TblUserId = data.id
          this.DataAxios.TblTaskUserIdTask = data.id
        }
      }
    },
    RemoveUser(item, user) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success mx-1',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      swalWithBootstrapButtons
        .fire({
          title: 'اطمینان دارید؟',
          text: 'از حذف ' + item.namFam + ' از دپارتمان ' + user.namFam + '؟',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'بله، حذف شود',
          cancelButtonText: 'لغو',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            var DataaxiosUserDelete = {
              Action: 'UserIdTask/B_Deleted',
              Method: 'Get',
              ArryfildValue: {
                Id: item.id,
              },
              Token: this.$session.get('Token'),
            }
            this.$GetData_Header(DataaxiosUserDelete)
              .then((response) => {
                this.$toasted.success("حذف با موفقیت صورت گرفت", {
                  action: {
                    text: "بستن",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                });
                this.getData()
              })
              .catch((error) => {
                console.error('CATCH', error)
                swalWithBootstrapButtons.fire('', 'عملیات با خطا مواجه شد', 'error')
              })
          }
        })
    },

  },
  mounted() {
    this.DataAxios.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
    this.getData()
  },



}
</script>
<style scoped>
.card {
  background: var(--sidebar-bg-color);
  border: solid 1px var(--logo-color);
}

.card-header {
  color: var(--logo-color);
  border: solid 1px var(--logo-color);
}

.hover-danger:hover {
  color: #a11414 !important;
  cursor: pointer;
}

u.text-info {
  font-size: 15px;
}

.badge {
  font-weight: normal !important;
  background: var(--sidebar-bg-color);
}

.badge:hover {
  cursor: pointer;
  font-size: medium;
  font-weight: bold;
  transform: 1s !important;
}
</style>